import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "lockCheck"
const LockCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.939 15.158 16.326 22.875 11.625 18.175 13.02 16.778 16.214 19.972 21.44 13.875z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C13.392 1.5 14.728 2.053 15.713 3.037 16.697 4.022 17.25 5.357 17.25 6.75V8.782C18.964 9.214 19.5 9.75 19.5 9.75V13.106L18 14.856V10.603Q17.807 10.52 17.525 10.423C16.588 10.111 14.88 9.75 12 9.75S7.412 10.11 6.475 10.423Q6.192 10.52 6 10.603V21H11.66L13.16 22.5H6C5.223 22.5 4.585 21.91 4.508 21.153L4.5 21V9.75S5.036 9.214 6.75 8.782V6.75C6.75 5.358 7.303 4.022 8.287 3.037 9.272 2.053 10.607 1.5 12 1.5M12 3C11.005 3 10.052 3.395 9.349 4.099 8.645 4.802 8.25 5.755 8.25 6.75V8.491C9.242 8.347 10.476 8.25 12 8.25S14.758 8.347 15.75 8.491V6.75C15.75 5.755 15.355 4.802 14.651 4.099 13.948 3.395 12.995 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LockCheckIcon
